import * as PIXI from 'pixi.js';

/**
 * サイトのWebGL
 */
import Cloud from './_cloud';

export default class EventGL {
    constructor() {
        this.init();
    }

    init() {
        this.cloud1 = null;
        this.cloud2 = null;
        this.loadAssets();
    }

    /**
     * アセットの読み込み
     */
    loadAssets() {
        const loader = new PIXI.Loader();

        const json_assets = {
            json_smoke1: './assets/img/top/ticket/smoke/smoke1.json',
            json_smoke2: './assets/img/top/ticket/smoke/smoke2.json',
        };

        const texture_assets = {
            texture_smoke: './assets/img/top/ticket/smoke/smoke.png',
        };

        Object.keys(json_assets).forEach((key) => {
            loader.add(key, json_assets[key]);
        });

        Object.keys(texture_assets).forEach((key) => {
            loader.add(key, texture_assets[key]);
        });

        loader.load((loader, assets) => {
            this.createPixi(assets);
        });
    }

    /**
     * PIXIの生成処理
     */
    createPixi(assets) {
        this.cloud1 = new Cloud(assets.json_smoke1, [assets.texture_smoke.texture], '.cloud_top');
        this.cloud2 = new Cloud(assets.json_smoke2, [assets.texture_smoke.texture], '.cloud_bottom');
    }
}
